import React from 'react';
import { Paper } from '@material-ui/core';
import { TabSectionHeader } from '../TabSections';
import { makeCss } from '../../../../../../knock-design-system';
import { SECTIONS } from '../constants';

const { DESCRIPTION, TITLE } = SECTIONS.FEATURED_AMENITIES;

const useCss = makeCss({
  paper: {
    marginBottom: '24px',
    padding: '20px 24px',
  },
});

const FeaturedAmenities = () => {
  const css = useCss();
  return (
    <div>
      <Paper css={css.paper} variant="outlined">
        <TabSectionHeader description={DESCRIPTION} title={TITLE} />
        {/* TODO - remove Add Featured Amenity placeholder with component */}
        Add Featured Amenity
      </Paper>
      {/* TODO - remove text placeholder with component */}
      Type in amenity name and press Enter in the boxes below, or select from
      our suggested options.
    </div>
  );
};

export default FeaturedAmenities;
